
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetosadeteenshaktipeeth() {



    const cardData =
    {
        keyword: 'Pune to Sade Teen Shakti Peeth Darshan Cabs',
        heading: 'Platinum24 Cabs: Pune to Sade Teen Shakti Peeth Darshan Cabs',
        headingDescription: ' Platinum24 Cabs provides reliable Pune to Sade Teen Shakti Peeth Darshan Cabs, ensuring a comfortable and spiritual journey to Maharashtra’s most sacred Shakti Peeth temples – Tuljapur Bhavani, Kolhapur Mahalaxmi, and Mahur Renuka Mata. Our fleet of hatchbacks, sedans, SUVs, and luxury cars offers safe and smooth travel across long routes with ample seating and modern amenities. With professional chauffeurs experienced in temple circuits, we guarantee timely darshan, flexible itineraries, and affordable packages. Whether it’s a family pilgrimage, group yatra, or multi-day temple tour, Platinum24 Cabs ensures safe, punctual, and spiritually fulfilling travel experiences.',

        top: 'Top Places to Visit in Sade Teen Shakti Peeth with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Tulja Bhavani Temple – Tuljapur",
    "description": "The Tulja Bhavani Temple in Tuljapur (Osmanabad district) is one of the three and a half Shakti Peethas of Maharashtra. Dedicated to Goddess Bhavani, the temple dates back to the 12th century. Legend says Chhatrapati Shivaji Maharaj received his sword ‘Bhavani Talwar’ here, making it a shrine of historic and spiritual significance. The temple is crowded during Navratri when lakhs of devotees visit. The sanctum houses a powerful granite idol of Goddess Bhavani. Tulja Bhavani is Maharashtra’s divine embodiment of strength and protection."
  },
  {
    "title": "Mahalaxmi Temple – Kolhapur",
    "description": "The Mahalaxmi Temple in Kolhapur, also known as Ambabai Mandir, is another major Shakti Peeth. Built in the 7th century, it is dedicated to Goddess Mahalaxmi, the goddess of wealth and prosperity. The temple is part of the revered Shakti Peethas where the divine power of Sati resides. Its stone carvings, deepmalas, and festivals attract thousands daily. Devotees believe darshan here fulfills desires of health, wealth, and success. Kolhapur Mahalaxmi is Maharashtra’s eternal seat of divine prosperity."
  },
  {
    "title": "Renuka Devi Temple – Mahur",
    "description": "The Renuka Devi Temple in Mahur (Nanded district) is the third full Shakti Peeth in Maharashtra. Situated atop a hill, it is dedicated to Goddess Renuka, mother of Parashurama. Pilgrims climb steps surrounded by forests to reach the temple, which offers panoramic views. It is one of the most revered shrines for devotees of the Shakta tradition. Navratri and Yatra festivals are celebrated with grandeur here. Mahur Renuka Devi is Maharashtra’s shrine of divine motherhood and protection."
  },
  {
    "title": "Saptashrungi Devi Temple – Vani (Half Peeth)",
    "description": "Saptashrungi Temple in Vani (Nashik district) is considered the half (Ardh) Shakti Peeth among the Sade Teen. Dedicated to Goddess Saptashrungi Nivasini, the temple is located amidst seven hills. Devotees climb 510 steps or use ropeway services to reach the shrine. The Devi is depicted with 18 hands, holding weapons that symbolize protection and power. Pilgrims visit in large numbers during Navratri. Saptashrungi is Maharashtra’s sacred half Peeth, radiating divine feminine energy."
  }
],



        "services": [
    {
      "name": "Pune to Sade Teen Shakti Peeth Taxi",
      "description": "Reliable taxi service from Pune to the sacred Sade Teen Shakti Peeth temples, providing pilgrims with comfortable and timely transportation. This service is designed to accommodate individual travelers, families, and groups, ensuring a smooth and stress-free journey with door-to-door pickups and drop-offs."
    },
    {
      "name": "Sade Teen Shakti Peeth Cab Booking Pune",
      "description": "Convenient and quick cab booking options for Sade Teen Shakti Peeth darshan from Pune, available online and via phone. Customers can select vehicle types and receive instant confirmation for a hassle-free pilgrimage planning experience."
    },
    {
      "name": "Pune Sade Teen Shakti Peeth Darshan Cabs",
      "description": "Specialized cab services tailored for the pilgrimage to the Sade Teen Shakti Peeth temples from Pune. These cabs focus on providing a spiritual journey experience with comfortable vehicles, experienced drivers, and flexible schedules to cover all important temple visits."
    },
    {
      "name": "Taxi for Sade Teen Shakti Peeth Pune",
      "description": "Dedicated taxi options from Pune to the Sade Teen Shakti Peeth temples, ensuring punctual pickups, reliable service, and knowledgeable drivers who are familiar with the routes and temple timings. Ideal for devotees seeking convenience and safety."
    },
    {
      "name": "Sade Teen Shakti Peeth Temple Taxi Pune",
      "description": "Temple-focused taxi service from Pune for the Sade Teen Shakti Peeth darshan, with vehicles equipped for passenger comfort during long drives and the flexibility to accommodate multiple temple visits in a single trip."
    },
    {
      "name": "Pune to Sade Teen Shakti Peeth Car Rental",
      "description": "Affordable and flexible car rental options for travelers heading to Sade Teen Shakti Peeth temples from Pune. Choose from a variety of vehicle types including hatchbacks, sedans, SUVs, and tempo travellers based on group size and budget."
    },
    {
      "name": "Affordable Taxi Pune to Sade Teen Shakti Peeth",
      "description": "Budget-friendly taxi services for pilgrims traveling from Pune to Sade Teen Shakti Peeth, combining affordability with quality. These taxis offer safe, clean, and well-maintained vehicles, ensuring a pleasant travel experience without breaking the bank."
    },
    {
      "name": "Sade Teen Shakti Peeth Pilgrimage Cab Pune",
      "description": "Pilgrimage-specific cab service offering customized itineraries covering all key Shakti Peeth temples. The service prioritizes spiritual convenience with flexible timing, door-to-door service, and a dedicated driver experienced in pilgrimage routes."
    },
    {
      "name": "Pune Sade Teen Shakti Peeth Taxi Packages",
      "description": "Comprehensive taxi packages from Pune for visiting the Sade Teen Shakti Peeth temples, including fuel, tolls, driver allowance, and optional sightseeing. Packages are designed to suit different group sizes and travel durations, providing great value and peace of mind."
    },
    {
      "name": "Taxi Service for Sade Teen Shakti Peeth from Pune",
      "description": "Reliable and professional taxi services dedicated to the Sade Teen Shakti Peeth pilgrimage route from Pune. Services include pickup/drop-off at your doorstep, well-maintained vehicles, and courteous drivers committed to making your spiritual journey memorable."
    },
    {
      "name": "Pune Sade Teen Shakti Peeth Temple Tour Taxi",
      "description": "Tour-focused taxi service designed to cover all temples within the Sade Teen Shakti Peeth circuit. The taxis offer comfortable seating, air conditioning, and the flexibility to customize the itinerary according to the devotee’s preferences and schedule."
    },
    {
      "name": "Sade Teen Shakti Peeth One Way Taxi Pune",
      "description": "Affordable one-way taxi options from Pune to the Sade Teen Shakti Peeth temples, ideal for travelers seeking point-to-point transfers without the obligation of a round trip. Perfect for flexible travel plans and budget-conscious pilgrims."
    },
    {
      "name": "Pune Sade Teen Shakti Peeth Taxi Charges",
      "description": "Transparent pricing structure for taxi services from Pune to Sade Teen Shakti Peeth, including detailed fare breakdowns with no hidden charges. Get customized quotes based on vehicle type, distance, and trip duration to suit your budget."
    },
    {
      "name": "Sade Teen Shakti Peeth Cab with Driver Pune",
      "description": "Professional chauffeur-driven cabs for the pilgrimage to Sade Teen Shakti Peeth from Pune. Drivers are experienced, courteous, and familiar with temple timings and routes, ensuring a safe, comfortable, and culturally enriched travel experience."
    },
    {
      "name": "Pune to Sade Teen Shakti Peeth Private Taxi",
      "description": "Exclusive private taxi services from Pune to the Sade Teen Shakti Peeth temples, offering personalized travel experiences with privacy, comfort, and flexibility. Ideal for families and groups looking for a dedicated vehicle and driver."
    }
  ],
  "tableData": [
    ["Pune to Sade Teen Shakti Peeth Taxi", "Sade Teen Shakti Peeth Cab Booking Pune"],
    ["Pune Sade Teen Shakti Peeth Darshan Cabs", "Taxi for Sade Teen Shakti Peeth Pune"],
    ["Sade Teen Shakti Peeth Temple Taxi Pune", "Pune to Sade Teen Shakti Peeth Car Rental"],
    ["Affordable Taxi Pune to Sade Teen Shakti Peeth", "Sade Teen Shakti Peeth Pilgrimage Cab Pune"],
    ["Pune Sade Teen Shakti Peeth Taxi Packages", "Taxi Service for Sade Teen Shakti Peeth from Pune"],
    ["Pune Sade Teen Shakti Peeth Temple Tour Taxi", "Sade Teen Shakti Peeth One Way Taxi Pune"],
    ["Pune Sade Teen Shakti Peeth Taxi Charges", "Sade Teen Shakti Peeth Cab with Driver Pune"],
    ["Pune to Sade Teen Shakti Peeth Private Taxi", "—"]
  ],


        "whychoose": [
    {
      "WhyChooseheading": "Reliable Pune to Sade Teen Shakti Peeth Darshan Cab Service",
      "WhyChoosedescription": "Platinum24 Cabs offers comfortable and trustworthy cabs for your pilgrimage to the Sade Teen Shakti Peeth temples."
    },
    {
      "WhyChooseheading": "Experienced Drivers Familiar with Darshan Routes",
      "WhyChoosedescription": "Our drivers have in-depth knowledge of the best routes to ensure a smooth and timely journey."
    },
    {
      "WhyChooseheading": "Spacious and Comfortable Vehicles for Group Travel",
      "WhyChoosedescription": "Travel comfortably with ample space for passengers and luggage on your spiritual tour."
    },
    {
      "WhyChooseheading": "Clean and Sanitized Fleet for Your Safety",
      "WhyChoosedescription": "We prioritize your health by regularly cleaning and sanitizing all vehicles before every trip."
    },
    {
      "WhyChooseheading": "Flexible Booking Options for One-Way and Round Trips",
      "WhyChoosedescription": "Choose from customizable packages tailored to your pilgrimage schedule."
    },
    {
      "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
      "WhyChoosedescription": "Enjoy upfront pricing inclusive of fuel, tolls, and driver allowances for worry-free travel."
    },
    {
      "WhyChooseheading": "24/7 Customer Support for Hassle-Free Bookings",
      "WhyChoosedescription": "Our dedicated team is available around the clock to assist you with bookings and any special requests."
    },
    {
      "WhyChooseheading": "Ideal for Family and Group Pilgrimages",
      "WhyChoosedescription": "Our Pune to Sade Teen Shakti Peeth cab services are perfect for families and groups seeking spiritual journeys."
    }
  ]































    }


const faqData = [
    {
        question: 'Does Platinum24 Cabs provide cab services from Pune to Sade Teen Shakti Peeth Darshan?',
        answer: 'Yes, Platinum24 Cabs offers reliable and comfortable cab services for Pune to Sade Teen Shakti Peeth Darshan trips.',
    },
    {
        question: 'How can I book a Pune to Sade Teen Shakti Peeth Darshan cab with Platinum24 Cabs?',
        answer: 'You can easily book your Pune to Sade Teen Shakti Peeth Darshan cab through our website, mobile app, or by contacting our customer support team.',
    },
    {
        question: 'What types of vehicles are available for Pune to Sade Teen Shakti Peeth Darshan trips?',
        answer: 'We offer a variety of vehicles including sedans, SUVs, and premium cars to suit your group size and travel preferences.',
    },
    {
        question: 'Are the drivers experienced with the Pune to Sade Teen Shakti Peeth Darshan route?',
        answer: 'Yes, our drivers are professional, experienced, and knowledgeable about the Sade Teen Shakti Peeth Darshan pilgrimage route.',
    },
    {
        question: 'Can I book a round trip cab for Pune to Sade Teen Shakti Peeth Darshan?',
        answer: 'Absolutely! We provide round-trip cab services with flexible scheduling to suit your pilgrimage plans.',
    },
    {
        question: 'What is included in the fare for Pune to Sade Teen Shakti Peeth Darshan cab services?',
        answer: 'The fare includes vehicle charges, driver allowance, fuel, tolls, and taxes. Additional charges may apply for extra stops or waiting time.',
    },
    {
        question: 'Can I customize pickup and drop-off locations for Pune to Sade Teen Shakti Peeth Darshan rides?',
        answer: 'Yes, you can specify your preferred pickup and drop-off points along the Pune to Sade Teen Shakti Peeth Darshan route.',
    },
    {
        question: 'Are safety measures in place for Pune to Sade Teen Shakti Peeth Darshan cab rides?',
        answer: 'All vehicles are regularly sanitized, and our drivers follow strict safety protocols for your protection.',
    },
    {
        question: 'Is it possible to hire a cab for multiple days for Pune to Sade Teen Shakti Peeth Darshan travel?',
        answer: 'Yes, we offer hourly and multi-day rental packages tailored to your pilgrimage needs.',
    },
    {
        question: 'Does Platinum24 Cabs provide corporate taxi services for Pune to Sade Teen Shakti Peeth Darshan?',
        answer: 'Yes, we offer customized corporate travel solutions including priority support and flexible billing for Pune to Sade Teen Shakti Peeth Darshan routes.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Vinay Kulkarni',
        feedback: 'The Pune to Sade Teen Shakti Peeth Darshan cab service was excellent. The driver was knowledgeable and courteous.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Shruti Desai',
        feedback: 'Booking a cab for Sade Teen Shakti Peeth Darshan was simple and the trip was comfortable and smooth.',
        rating: 5,
    },
];









































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];







const sadeTeenShaktiPeethCabsSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Sade Teen Shakti Peeth Darshan Cabs",
  "image": "https://www.platinum24cab.com/assets/images/sade-teen-shakti-peeth-darshan-cab.jpg",
  "description": "Book Pune to Sade Teen Shakti Peeth Darshan cab with Platinum24 Cabs. Comfortable AC cars, tempo travellers, and private taxis available for temple tours with professional drivers and flexible packages.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2999",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/pune-to-sade-teen-shakti-peeth-darshan-cabs"
  }
};






    return (
        <div>

<Helmet>
  <title>Pune to Sade Teen Shakti Peeth Darshan Cabs | Temple Tour Taxi | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Book Pune to Sade Teen Shakti Peeth Darshan cab with Platinum24 Cabs. AC cars, tempo travellers & private taxis for Shakti Peeth temple tours. Experienced drivers & flexible plans."
  />
  <meta
    name="keywords"
    content="Pune to Sade Teen Shakti Peeth Taxi, Sade Teen Shakti Peeth Cab Booking Pune, Pune Sade Teen Shakti Peeth Darshan Cabs, Taxi for Sade Teen Shakti Peeth Pune, Sade Teen Shakti Peeth Temple Taxi Pune, Pune to Sade Teen Shakti Peeth Car Rental, Affordable Taxi Pune to Sade Teen Shakti Peeth, Sade Teen Shakti Peeth Pilgrimage Cab Pune, Pune Sade Teen Shakti Peeth Taxi Packages, Taxi Service for Sade Teen Shakti Peeth from Pune, Pune Sade Teen Shakti Peeth Temple Tour Taxi, Sade Teen Shakti Peeth One Way Taxi Pune, Pune Sade Teen Shakti Peeth Taxi Charges, Sade Teen Shakti Peeth Cab with Driver Pune, Pune to Sade Teen Shakti Peeth Private Taxi"
  />
  <script type="application/ld+json">
    {JSON.stringify(sadeTeenShaktiPeethCabsSchema)}
  </script>
</Helmet>


            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/34.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetosadeteenshaktipeeth;